import type { GeoArVisibilityState } from "../types/GeoArState.js";

export interface VisibilityInput {
  distance: number;
  relativeAngle: number | null;
  fieldOfView: number;
  maxDistance: number;
}

export function calculateVisibility(input: VisibilityInput): GeoArVisibilityState {
  if (input.distance > input.maxDistance) {
    return "TOO_FAR";
  }

  if (input.relativeAngle === null) {
    return "NO_INFORMATION";
  }

  const halfFov = input.fieldOfView / 2;
  return Math.abs(input.relativeAngle) <= halfFov ? "VISIBLE" : "OUTSIDE_VIEW";
}
